/**
 * Mobile Add Option Dialog Component
 * Extracted from CreateTransactionMobile.tsx
 * 
 * Dialog for adding new detail options
 */

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

export interface MobileAddOptionDialogProps {
  open: boolean;
  value: string;
  detailName: string;
  error: string;
  onClose: () => void;
  onValueChange: (value: string) => void;
  onAdd: () => void;
  checkDuplicateOption: (value: string, detailName: string) => string;
}

export default function MobileAddOptionDialog({
  open,
  value,
  detailName,
  error,
  onClose,
  onValueChange,
  onAdd,
  checkDuplicateOption,
}: MobileAddOptionDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center", position: "relative" }}>
        Add New Option
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <TextField
          autoFocus
          margin="dense"
          label="Option Name"
          fullWidth
          variant="outlined"
          value={value}
          onChange={(e) => {
            const newValue = e.target.value;
            onValueChange(newValue);
            // Note: Error state is managed by parent component via checkDuplicateOption
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter" && !error && value.trim()) {
              e.preventDefault();
              onAdd();
            }
          }}
          error={!!error}
          helperText={error}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2, pt: 1, gap: 1, display: "flex" }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ flex: 1, py: 1.5 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onAdd}
          variant="contained"
          disabled={!value.trim() || !!error}
          sx={{ flex: 1, py: 1.5 }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
